export default __webpack_public_path__ + "static/media/Kat Kun Stick Shrimp Flavour.0c7e5574.png";